import { Component, OnInit, Input } from '@angular/core';

import { CampEnrollmentApiService } from '../../../services/api/camp-enrollment-api.service';
import { CampsEnumTranslationService } from '../../../services/camps-enum-translation.service';
import { camps } from '../../../models/models.generated';

@Component({
    selector: 'app-session-enrollment-item',
    templateUrl: './session-enrollment-item.component.html',
    styleUrls: ['./session-enrollment-item.component.scss'],
    standalone: false
})
export class SessionEnrollmentItemComponent implements OnInit {

    @Input() public session: camps.CampEnrollmentSessionInfo;

    public dayVariants: Array<camps.CampEnrollmentSessionDaysVariantDetails> = [];
    public selectedDaysVariant: camps.CampEnrollmentSessionDaysVariantDetails;

    public showDetails: boolean = false;
    private isBusy: boolean = false;

    constructor(private enrollmentApiService: CampEnrollmentApiService
        , public campsEnumTranslation: CampsEnumTranslationService
    ) { }

    ngOnInit() {
    }

    public onShowDetails(): void {
        this.showDetails = !this.showDetails;
        
        if(this.showDetails){
            if(this.session.noOfDays.length > 0){
                this.onDayVariantDetails(this.session.noOfDays[0].id);
            }
        }
    }

    public onDayVariantDetails(id: camps.Guid):void{
        let existingDayVariant = this.dayVariants.filter(x => x.id == id);
        if(existingDayVariant.length > 0){
            this.selectedDaysVariant = existingDayVariant[0];
        } else {
            this.loadDetails(id);
        }
    }

    private loadDetails(id: camps.Guid): void {
        this.isBusy = true;
        this.enrollmentApiService.getDayVariantDetails(id).subscribe(response => {
            this.dayVariants.push(response.value);
            this.onDayVariantDetails(id);
            this.isBusy = false;
        }, () => { this.isBusy = false; });
    }

}
